/**
 * Verifies segment integrity using the Web Crypto API (SHA-256).
 */
export class SegmentVerifier {
  /**
   * Returns true if the sha256 hex digest of data matches expected.
   */
  async verify(data: ArrayBuffer, expectedHex: string): Promise<boolean> {
    if (!expectedHex) return false;

    const hashBuf = await crypto.subtle.digest('SHA-256', data);
    const actual = this.bufToHex(hashBuf);
    return actual === expectedHex.toLowerCase();
  }

  private bufToHex(buf: ArrayBuffer): string {
    const bytes = new Uint8Array(buf);
    return Array.from(bytes)
      .map((b) => b.toString(16).padStart(2, '0'))
      .join('');
  }
}
